import React from 'react';

function EmailStar({ color = '#335B70', ...props }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                fill={color}
                d="M12 13 4 8v10h8c0 .35.025.688.075 1.012.05.325.125.655.225.988H4c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 2 18V6c0-.55.196-1.02.587-1.412A1.926 1.926 0 0 1 4 4h16c.55 0 1.02.196 1.413.588.391.391.587.862.587 1.412v5.7c-.3-.15-.62-.275-.962-.375A7.43 7.43 0 0 0 20 11.1V8l-8 5Zm0-2 8-5H4l8 5Z"
            />
            <path
                fill={color}
                d="m16.767 20.154 1.733-1.045 1.733 1.058-.454-1.98 1.526-1.32-2.008-.178-.797-1.87-.797 1.856-2.008.179 1.526 1.334-.454 1.966Zm-1.663 2.296.894-3.864L13 15.988l3.96-.344L18.5 12l1.54 3.644 3.96.344-2.997 2.598.893 3.864-3.396-2.049-3.396 2.049Z"
            />
        </svg>
    );
}

export default EmailStar;
